export default {
  defaultWarningTitle: "Heads Up!",
};
